import { render, staticRenderFns } from "./i-multi-select.vue?vue&type=template&id=d023987e&scoped=true&"
import script from "./i-multi-select.vue?vue&type=script&lang=js&"
export * from "./i-multi-select.vue?vue&type=script&lang=js&"
import style0 from "./i-multi-select.vue?vue&type=style&index=0&id=d023987e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d023987e",
  null
  
)

export default component.exports